import type { HTTPError } from "@twiage/http/types/HTTPError";

export const isHttpError = (error: unknown): error is HTTPError => {
  return error instanceof Error && error.name === "HTTPError";
};
